var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My Portfolio"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5036 2.68899C16.5036 1.36814 15.4304 0.294922 14.1095 0.294922H5.79904C4.47819 0.294922 3.39947 1.36814 3.39947 2.68899V10.9995C3.39947 11.4728 3.53706 11.9131 3.78473 12.2873L10.4166 6.21683C11.5723 5.16562 13.273 5.05554 14.5498 5.94712L16.5036 7.30103V2.68899ZM7.47764 6.31038C6.40994 6.31038 5.5459 5.4408 5.5459 4.37309C5.5459 3.30539 6.40994 2.43584 7.47764 2.43584C8.54535 2.43584 9.41493 3.30539 9.41493 4.37309C9.41493 5.4408 8.54535 6.31038 7.47764 6.31038ZM11.7983 15.7052H3.48781C2.16696 15.7052 1.09375 14.632 1.09375 13.3111V5.00068C1.09375 4.11461 1.57807 3.33307 2.29905 2.92581V10.9997C2.29905 12.9314 3.86757 14.5 5.79934 14.5H13.8787C13.4659 15.2209 12.6844 15.7052 11.7983 15.7052ZM6.64682 4.37289C6.64682 3.91061 7.02107 3.53636 7.47784 3.53636C7.94016 3.53636 8.31441 3.91061 8.31441 4.37289C8.31441 4.83521 7.94016 5.20946 7.47784 5.20946C7.02107 5.20946 6.64682 4.83521 6.64682 4.37289ZM4.57221 13.0524L11.16 7.0314C11.9306 6.32692 13.0643 6.25537 13.9229 6.84977L16.5041 8.63845V10.9995C16.5041 12.3204 15.4309 13.3991 14.11 13.3991H5.79951C5.35372 13.3991 4.92993 13.2725 4.57221 13.0524Z",
    fill: "#848484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.0e66ba3e31a9bd41febb26e5d6e573a6.svg";
export { ForwardRef as ReactComponent };